<template>
    <div :class="[
        'form-group',
        'form-group--float', {
            'has-error': hasErrors,
            'form-group--active': isNotEmpty,
            'form-group--disabled': disabled,
        }]">
        <h6>
            <label :for="name">
                <slot>{{ name }}</slot>{{ required ? ' *' : '' }}
            </label>
        </h6>
        <textarea
            class="text-area"
            v-bind="$attrs"
            :name="name"
            :id="name"
            :value="value"
            :disabled="disabled"
            :required="required"
            @input="onInput">
        </textarea>

        <div v-if="hasErrors" class="form-group__errors">
            <p>{{ errors[0] }}</p>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'SaxxTextArea',
    props: {
        form: {
            required: true,
            type: String,
        },
        name: {
            required: true,
            type: String
        },
        validator: {
            required: false,
            type: Function,
            default: () => true,
        },
        required: {
          required: false,
          type: Boolean,
          default: false
        },
    },
    computed: {
        ...mapGetters('forms', [
            'getField',
            'getErrors',
            'getFieldIsDisabled',
        ]),
        value() {
            return this.getField({
                form: this.form,
                field: this.name,
            });
        },
        errors() {
            return this.getErrors({
                form: this.form,
                field: this.name,
            });
        },
        hasErrors() {
            return this.errors.length > 0;
        },
        isNotEmpty() {
            return (
                String(this.value).length > 0
            );
        },
        disabled() {
            return this.getFieldIsDisabled({ form: this.form, field: this.name });
        },
    },
    methods: {
        ...mapActions('forms', [
            'setField',
        ]),
        onInput(event) {
            const value = event.target.value;
            if (!this.validator(value)) {
                return;
            }

            this.setField({
                form: this.form,
                field: this.name,
                value,
            });
        },
    },
}
</script>
